import { pointingTypeOrder, pointingTypeText, positionCategoryOrder, positionCategoryText } from '@/enum';

const common = {
  namespaced: true,

  state: {},

  getters: {
    // 位置分类选择项
    positionCategoryOptions() {
      return positionCategoryOrder.map(item => {
        return {
          label: positionCategoryText[item],
          value: item,
        };
      });
    },

    // 指向类型选项
    pointingTypeOptions() {
      return pointingTypeOrder.map(item => {
        return {
          label: pointingTypeText[item],
          value: item,
        };
      });
    },
  },

  mutations: {},

  actions: {},
};

export default common;
